
import styled from 'styled-components'; // Needed for styled components
// import rocketIcon from 'assets/rocket-icon.png'; // Import rocket icon if StyledMissionList/Item is used here

import rocketIcon from 'pages_centennial/assets/icons/rocket-icon.png'; // Import rocket icon if StyledMissionList/Item is used here



// --- THEME COLORS ---
export const colors = {
    textColor: '#ffffff',
    accentColor: '#19abf0',
    cardBorder: 'rgba(255, 255, 255, 0.5)',
    accentColorDarker: '#006993'
};


export const introBannerStyles3 = {
    backgroundColor: 'rgba(0, 0, 0, 0.6)',
    color: colors.textColor,
    //padding: '10px',
    borderRadius: '10px',
    border: '1px solid white',
    //boxShadow: '0 0 20px rgba(0,0,0,0.5)',
    textAlign: 'center',
    marginTop: '2rem',
    marginLeft: '0%',
    marginRight: '0%',
    //marginRight: '2%',
    marginBottom: '2rem',
    width: '80%',
     //maxWidth: '900px',
    //minHeight: '180px',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',

    fontFamily: 'roboto_regular',

};





// --- Styled Components (CSS-in-JS) ---
export const StyledMissionList = styled.ul`
    list-style: none; /* Crucial: removes default bullets */
    padding-left: 0;
    font-size: 1.5rem;
    font-family: 'roboto_regular', sans-serif;
`;

export const StyledMissionListItem_ORIGINAL = styled.li`
    position: relative;
    padding-left: 20px; /* Space for the icon + gap */
    margin-bottom: 8px;
    font-size: 0.9rem;
    font-family: 'orbitron_regular', sans-serif;
    line-height: 1.2;
    text-align:left;

    &::before {
        content: ""; /* Must be present */
        position: absolute;
        left: 0;
        top: 50%;
        transform: translateY(-50%); /* For perfect vertical centering */
        width: 16px; /* Adjust size of your icon */
        height: 16px; /* Adjust size of your icon */
        background-image: url(${rocketIcon}); /* Uses the imported image */
        background-size: contain;
        background-repeat: no-repeat;
        background-position: center;
    }
`;



export const StyledMissionListItem = styled.li`
    position: relative;
    padding-left: 20px; /* Space for the icon + gap */
    margin-bottom: 8px;
    font-size: 0.9rem;
    font-family: 'orbitron_regular', sans-serif;
    line-height: 1.2;
    text-align:left;

    &::before {
        content: ""; /* Must be present */
        position: absolute;
        left: 5px;
        top: 0.5rem;
        transform: translateY(-50%); /* For perfect vertical centering */
        width: 12px; /* Adjust size of your icon */
        height: 12px; /* Adjust size of your icon */
        background-image: url(${rocketIcon}); /* Uses the imported image */
        background-size: contain;
        background-repeat: no-repeat;
        background-position: center;
    }
`;







// --- Styled Components (CSS-in-JS) ---
export const StyledMissionListNested = styled.ul`
    list-style: none; /* Crucial: removes default bullets */
    padding-left: 0;
    font-size: 1.5rem;
    font-family: 'roboto_regular', sans-serif;
`;

export const StyledMissionListItemNested_ORIGINAL = styled.li`
    position: relative;
    padding-left: 20px; /* Space for the icon + gap */
    margin-bottom: 8px;
    font-size: 0.9rem;
    font-family: 'orbitron_regular', sans-serif;
    line-height: 1.2;
    text-align:left;

    &::before {
        content: ""; /* Must be present */
        position: absolute;
        left: 0;
        top: 50%;
        transform: translateY(-50%); /* For perfect vertical centering */
        width: 16px; /* Adjust size of your icon */
        height: 16px; /* Adjust size of your icon */
        background-image: url(${rocketIcon}); /* Uses the imported image */
        background-size: contain;
        background-repeat: no-repeat;
        background-position: center;
    }
`;




export const StyledMissionListItemNested_V2 = styled.li`
    position: relative;
    padding-left: 20px; /* Space for the icon + gap */
    margin-bottom: 8px;
    font-size: 0.9rem;
    font-family: 'orbitron_regular', sans-serif;
    text-align:left;
    color: white; /* Explicitly set the text color to white */

    &::before {
        content: "•"; /* <-- CHANGED: Use a simple bullet character */
        position: absolute;
        left: 0;
    
        color: white; /* <-- CHANGED: Set the bullet color to white */
        font-size: 2em;
        line-height: 1;
    }
`;




export const StyledMissionListItemNested_V3 = styled.li`
    position: relative;
    padding-left: 20px;
    margin-bottom: 8px;
    font-size: 0.9rem;
    font-family: 'orbitron_regular', sans-serif;
    text-align:left;
    color: white;

    &::before {
        content: "•";
        position: absolute;
        left: 0;
        top: 0;
        color: white;
        font-size: 3rem;
        line-height: 1;
    }
`;





export const StyledMissionListItemNested_V4 = styled.li`
    position: relative;
    padding-left: 20px;
    margin-bottom: 8px;
    font-size: 0.9rem;
    font-family: 'orbitron_regular', sans-serif;
    text-align:left;
    color: white;
    line-height: 1.2;
    list-style-type: square;

    &::before {
        content: "•";
        position: absolute;
        left: 0;
        top: 0;
        color: white;
        font-size: 3rem; /* Make the bullet larger */
        /* Use transform to move it up by a percentage of its own height */
        transform: translateY(-25%);
        line-height: 1;
    }
`;

export const StyledMissionListItemNested = styled.li`
    position: relative;
    padding-left: 5px;
    margin-left: 30px;
    font-size: 0.9rem;
    font-family: 'orbitron_regular', sans-serif;
    text-align:left;
    color: white;
    line-height: 1.2;
    list-style-type: square;

  
`;











export const introHeadingStyles = {
    fontSize: '1.7rem',
    color: colors.accentColor,
    marginBottom: '15px',
    fontFamily: 'orbitron_medium',
};
export const introSubHeadingStyles = {
    fontSize: '1.3rem',
    color: colors.textColor,
    marginBottom: '20px',
    fontFamily: 'roboto_regular',
    //maxWidth: '600px',
};



export const squareBulletStyle = {
    listStyleType: 'square',
};